module.exports = __webpack_public_path__ + "media/src/images/icons/white-chevron-forward-4b4ba64e92a6acfd926be95e4cb17fe1.svg";